import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    EBON_ACTIVATION_TYPE_ONLINE,
    EBON_ACTIVATION_TYPE_OFFLINE,
    EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE,
    ENTERPRISE_CARD_NAME,
    ENTERPRISE_CARD_PARTNER_EBC_ID
} from '../../constants/ebon';
import { STATIC_ROOT } from '../../constants';

import {
    getMerchantCardUrl,
    displayableCashback,
    hasCashback,
    hasEbon
} from '../../services/partner/utils';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import SvgComponent from '../SvgComponent';
import LogoPartenaireComponent from './LogoPartenaireComponent';
import LinkButtonComponent from '../button/LinkButtonComponent';
import CodePromoBlocPartenaireComponent from './CodePromoBlocPartenaireComponent';
import CashbackBlocPartenaireComponent from './CashbackBlocPartenaireComponent';

import './PartnerBlockComponent.scss';
import gtm from '../../utils/gtmUtils';

class PartnerBlockComponent extends React.Component {
    getEbonAvailability = ebonDiscount => {
        const { i18n } = this.props;

        if (ebonDiscount.activationType === EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE) {
            return i18n.EBON_TYPE_ON_OFF;
        } else if (ebonDiscount.activationType === EBON_ACTIVATION_TYPE_ONLINE) {
            return i18n.EBON_TYPE_ON;
        } else if (ebonDiscount.activationType === EBON_ACTIVATION_TYPE_OFFLINE) {
            return i18n.EBON_TYPE_OFF;
        }
        return null;
    };

    getEbonPartnerCashbackCumulable = partner => {
        const { i18n, partners } = this.props;

        if (partner.ebonDiscount.cumulativeWithCashbackDiscount) {
            const onlinePartner = partners[partner.id] ? partners[partner.id] : null;
            if (hasCashback(onlinePartner)) {
                const discount = onlinePartner.mostDisplayableDiscountOnline;
                let onlineCashback = onlinePartner.isMultiDiscount ? `${i18n.jusqua} ` : '';
                onlineCashback += `${displayableCashback(discount.percent, discount.fixed)} `;
                return (
                    <div className="ebonCumul">
                        {convertHtmlToReactDomWithParams(
                            i18n.EBON_CASHBACK_CUMULABLE,
                            onlineCashback
                        )}
                    </div>
                );
            }
        }
        return <div className="ebonCumul noCb">{i18n.EBON_CASHBACK_NOT_CUMULABLE}</div>;
    };

    render() {
        const { i18n, partner, urlCustom, isCodePromo, isOffline, hideType, isEbon } = this.props;

        const urlFicheMarchand = partner ? getMerchantCardUrl(partner, isOffline, isEbon) : null;
        const ebonCbCumulable =
            isEbon && hasEbon(partner) && this.getEbonPartnerCashbackCumulable(partner);

        const isEnterpriseCard = partner && partner.ebcId === ENTERPRISE_CARD_PARTNER_EBC_ID;
        const partnerName = isEnterpriseCard ? ENTERPRISE_CARD_NAME : partner ? partner.name : '';

        return (
            partner && (
                <article className="bloc-partenaire txtcenter flex-container-v flex-center-alt">
                    {!hideType && (
                        <div className="type">
                            {isOffline ? (
                                <React.Fragment>
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/picto-magasin.svg`}
                                        className="picto"
                                        width="15"
                                        height="18"
                                    />
                                    <span>
                                        {convertHtmlToReactDomWithParams(i18n.OFFER, i18n.OFFLINE)}
                                    </span>
                                </React.Fragment>
                            ) : isEbon ? (
                                <React.Fragment>
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/picto-ebon.svg`}
                                        className="picto"
                                        width="20"
                                        height="18"
                                    />
                                    <span>
                                        {convertHtmlToReactDomWithParams(i18n.OFFER, i18n.EBON)}
                                    </span>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/picto-en-ligne.svg`}
                                        className="picto"
                                        width="15"
                                        height="15"
                                    />
                                    <span>
                                        {convertHtmlToReactDomWithParams(i18n.OFFER, i18n.ONLINE)}
                                    </span>
                                </React.Fragment>
                            )}
                        </div>
                    )}
                    <LogoPartenaireComponent
                        partenaire={partner}
                        url={urlFicheMarchand}
                        title={partnerName}
                        cssClass="logo"
                    />
                    <hr />
                    {isCodePromo ? (
                        <CodePromoBlocPartenaireComponent
                            partner={partner}
                            cssClassContainer="blp-reduction"
                        />
                    ) : (
                        <CashbackBlocPartenaireComponent
                            partner={partner}
                            cssClassContainer="blp-reduction"
                            isOffline={isOffline}
                            isEbon={isEbon}
                            ebonCbCumulable={ebonCbCumulable}
                        />
                    )}
                    <div className="bt-conteneur w100">
                        <LinkButtonComponent
                            onClick={() =>
                                gtm.event('buy', {
                                    partner: { name: partner.name, id: partner.id },
                                    ebon: isEbon
                                })
                            }
                            to={urlCustom ? urlCustom : urlFicheMarchand}
                            title={partnerName}
                            text={isEbon ? i18n.jachete : i18n.jenprofite}
                            color="main"
                        />
                    </div>
                    {isEbon && hasEbon(partner) && (
                        <div className="ebonValidity">
                            {this.getEbonAvailability(partner.ebonDiscount)}
                        </div>
                    )}
                </article>
            )
        );
    }
}

PartnerBlockComponent.propTypes = {
    urlCustom: PropTypes.string,
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    partner: PropTypes.object,
    hideType: PropTypes.bool
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.partenaire,
        partners: state.partner.partners
    };
}

export default connect(mapStateToProps)(PartnerBlockComponent);



// WEBPACK FOOTER //
// ./src/components/partner/PartnerBlockComponent.js